import styled from 'styled-components';

export const FilterOverlay = styled.div`
    background: var(--background-app);
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow: hidden;
`;

export const CloseButton = styled.button`
    align-self: flex-end;
    width: 30px;
    height: 30px;
    border: none;
    background: transparent;
    color: var(--primary-color);
    font-size: 40px;
    line-height: 1;
    cursor: pointer;
    z-index: 1;
    padding: 0 32px;
`;

export const FilterContainer = styled.div`
    padding: 24px 0;
    background: var(--background-app);
    font-family: var(--font-family-base);
    text-align: left;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
`;

export const FilterHeading = styled.h2`
    font-size: 24px;
    font-weight: 600;
    color: var(--title-color);
    margin: 0 0 32px;
    line-height: 1.5;
    padding: 0 32px;
`;

export const SectionStack = styled.div`
    padding: 0 32px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    flex: 1;
    overflow-y: auto;
    overscroll-behavior: contain;
`;

export const FilterSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export const FilterTitle = styled.h3`
    font-size: 20px;
    font-weight: 600;
    color: var(--title-color);
    margin: 0;
    line-height: 1;
    letter-spacing: -0.8px;
`;

export const CheckboxGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    input[type="checkbox"],
    input[type="radio"] {
        appearance: none;
        width: 20px;
        height: 20px;
        border: 2px solid var(--primary-color);
        background: var(--background-app);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin: 0;
        cursor: pointer;
        position: relative;
    }

    input[type="checkbox"] {
        border-radius: 4px;
    }

    input[type="radio"] {
        border-radius: 50%;
    }

    input[type="checkbox"]:checked {
        background: var(--primary-color);
    }

    input[type="checkbox"]:checked::after {
        content: "";
        width: 6px;
        height: 10px;
        border: 2px solid var(--button-primary-text);
        border-top: 0;
        border-left: 0;
        transform: rotate(45deg);
        margin-bottom: 2px;
    }

    input[type="radio"]:checked::after {
        content: "";
        width: 10px;
        height: 10px;
        background: var(--primary-color);
        border-radius: 50%;
    }

    .form-check-label {
        font-size: 14px;
        color: var(--text-color);
        letter-spacing: -0.8px;
        line-height: 1;
    }

    input[type="checkbox"]:checked + .form-check-label,
    input[type="radio"]:checked + .form-check-label {
        color: var(--primary-color);
    }
`;

export const PriceRangeContainer = styled.div`
    width: 100%;
`;

export const PriceGrid = styled.div`
    display: flex;
    width: 100%;
    box-sizing: border-box;
    gap: 16px;
    align-items: center;
`;

export const PriceInput = styled.input`
    width: 100%;
    box-sizing: border-box;
    background: var(--background-app);
    border: 1px solid rgba(133, 163, 167, 0.33);
    border-radius: 4px;
    padding: 16px;
    height: 54px;
    font-size: 14px;
    outline: none;
    color: var(--text-color);
`;

export const InputFloatingContainer = styled.div`
    position: relative;
    flex: 0 1 calc(50% - 8px);

    label {
        position: absolute;
        top: 16px;
        left: 16px;
        font-size: 14px;
        pointer-events: none;
        transition: all 0.2s ease-out;
        transform-origin: left top;
        color: var(--text-color);
    }

    input:focus ~ label,
    input:not(:placeholder-shown) ~ label {
        top: 10px;
        left: 16px;
        font-size: 12px;
        background: transparent;
    }

    input {
        padding-top: 22px;
        padding-bottom: 8px;
        padding-left: 16px;
        padding-right: 16px;
    }
`;


export const FilterFooter = styled.div`
    margin-top: auto;
    padding: 24px 32px 0 32px;
`;

export const FilterActions = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
`;

export const ApplyButton = styled.button`
    width: 50%;
    max-width: 350px;
    background: var(--primary-color);
    color: var(--button-primary-text);
    border: 1px solid var(--primary-color);
    padding: 10px;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.8px;
    text-transform: uppercase;
    cursor: pointer;
`;

export const ClearButton = styled.button`
    width: 50%;
    max-width: 350px;
    background: var(--background-app);
    color: var(--primary-color);
    border: 1px solid var(--primary-color);
    padding: 10px;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.8px;
    text-transform: uppercase;
    cursor: pointer;
`;